import controller from './controller';

const AirControl = ({
  description = 'ac off',
  icon = 'assets/images/icon-fan-gray.svg',
}) => {
  return `
    <button class="air-control" aria-label="Air Control" id="air-control">
        <span id="air-description" class="off">${description}</span>
        <img src="${icon}" title="Air Control" alt="Air control" />
    </button>
`;
};

const BatteryController = () => `
    <section class="battery-controller" role="region">
        <form class="controllers" name="controllers" role="form">
            <fieldset class="container speed divider">
                <legend>Speed</legend>
                <div class="wrapper">
                    <input id="speed" type="number" min="70" max="140" name="speed" value="100" step="10" />
                    <span>KMH</span>
                    <div class="range-controls">
                        <button id="speed-up" aria-label="Speed Up">
                            <img src="assets/images/icon-thin-chevron-up.svg" title="Speed Up"  alt="Speed up" />
                        </button>
                        <button id="speed-down" aria-label="Speed Down">
                            <img src="assets/images/icon-thin-chevron-down.svg" title="Speed Down" alt="Speed down"  />
                        </button>
                    </div>
                </div>
            </fieldset>
            <fieldset class="container temperature divider">
                <legend>Outside temperature</legend>
                <div class="wrapper">
                    <input id="temperature" type="number" min="-10" max="40" step="10" name="temperature" value="20" readonly />
                    <div class="range-controls">
                        <button id="temperature-up" aria-label="Temperature Up">
                            <img src="assets/images/icon-thin-chevron-up.svg" title="Temperature Up"  alt="Temperature up" />
                        </button>
                        <button id="temperature-down" aria-label="Temperature Down">
                            <img src="assets/images/icon-thin-chevron-down.svg" title="Temperature Down" alt="Temperature down"  />
                        </button>
                    </div>
                </div>
                ${AirControl({})}
            </fieldset>
            <fieldset class="container wheels">
                <legend>Wheels</legend>
                <button id="wheel-19" class="wrapper wheel-19 selected" aria-label="19 wheel size">
                    <img src="assets/images/icon-wheel.svg" alt="19 wheel size" />
                        19″
                </button>
                 <button id="wheel-21" class="wrapper wheel-21" aria-label="21 wheel size">
                        <img src="assets/images/icon-wheel.svg" alt="21 wheel size" />
                        21″
                </button>
            </fieldset>
        </form>
        <p class="text">
            The actual amount of range that you experience will vary based on your particular use conditions. Your vehicle range is also dependent on other conditions, such as vehicle configuration, battery age and condition, driving style and operating, environmental and climate conditions. See how some of these particular use conditions may affect your range in our simulation model.
        </p>
    </section>
`;

window.addEventListener('DOMContentLoaded', controller);

export default BatteryController;
